
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { UserInterface, UserRepoInterface } from '@/services/Users/Interfaces';
import { WPXFormValue } from '@/components/templates/WPXForm';
import AddAgentForm from '@/services/Dossier/user/forms/AddAgentForm';
import DossierPositionRepositoryInterface, { AgentPositionInterface } from '@/services/Dossier/position/interfaces';
import DossierUserRepositoryInterface from '@/services/Dossier/user/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'dossierUserRepository',
    'dossierPositionRepository',
    'userRepository',
    'profileRepository',
  ],
})
export default class AddAgent extends Vue {
  private form: WPXFormValue<AddAgentForm> = new WPXFormValue(AddAgentForm);

  private loading: boolean = true;

  private dossierPositionRepository!: DossierPositionRepositoryInterface;
  private dossierUserRepository!: DossierUserRepositoryInterface;
  private userRepository!: UserRepoInterface;

  private positions: AgentPositionInterface[] = [];
  private users: UserInterface[] = [];

  private async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    try {
      this.positions = await this.dossierPositionRepository.getAllPositions();
      const agents = await this.dossierUserRepository.getAllUsers();
      const [users] = await this.userRepository.getAllUsers();
      this.users = users.filter((user) => !agents.find((agent) => agent.id === user.id));
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show(e?.response?.data?.message || e.message);
    }
  }

  private async addAgent(): Promise<void> {
    try {
      await this.dossierUserRepository.createUser({
        users: this.form.data.users,
        positionId: this.form.data.positionId,
      });
      this.users = this.users.filter((user) => !this.form.data.users.includes(user.id));
      this.form.data.users = [];
      this.$successDialog.show('Agent added successfully');
    } catch (e) {
      this.$errorDialog.show(e?.response?.data?.message || e.message);
    }
  }

  private async goBack(): Promise<void> {
    await this.$router.push({ name: 'all-agents' });
  }
}
